import { type ReactNode, createContext, useContext } from "react";

/**
 * CR-126: where Figma context cards may render. A surface that shows pasted
 * Figma links (the chat page today, documents in stage 5) provides its project;
 * without a scope no card renders — e.g. document comment threads, which share
 * the message renderer.
 */
export interface FigmaContextScopeValue {
  /** The project the imports belong to (membership is checked on it). */
  projectId: string;
  workspaceSlug: string;
  projectSlug: string;
}

const FigmaContextScopeContext = createContext<FigmaContextScopeValue | null>(null);

export function FigmaContextScope({
  value,
  children,
}: {
  /** null renders no cards below (e.g. a route without project slugs). */
  value: FigmaContextScopeValue | null;
  children: ReactNode;
}) {
  return (
    <FigmaContextScopeContext.Provider value={value}>{children}</FigmaContextScopeContext.Provider>
  );
}

export function useFigmaContextScope(): FigmaContextScopeValue | null {
  return useContext(FigmaContextScopeContext);
}
